// removed by extract-text-webpack-plugin
module.exports = {"chartDetails":"ChartLineGraph__chartDetails"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartLineGraph/ChartLineGraph.scss
// module id = ./src/components/ChartLineGraph/ChartLineGraph.scss
// module chunks = 2